"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const RadioSchemaComponent = (props) => {
    const { value, registerProps, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const [radioId] = (0, react_1.useState)(Math.random().toString().slice(2));
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement("div", { className: (0, classnames_1.default)({
                "d-flex": props.schema.horizontal,
                "gap-3": props.schema.horizontal,
            }) }, props.schema.options.map((option, index) => (react_1.default.createElement(Form_1.default.Check, Object.assign({ key: index, type: "radio", label: option.label, value: option.value, className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), defaultChecked: value === option.value, id: `radio-${radioId}-${index}` }, registerProps)))))));
};
RadioSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("BooleanDisplayComponent", (value, schema) => {
    if (schema.view === "form") {
        return react_1.default.createElement("span", { className: "readonly-field" }, value);
    }
    return value;
});
exports.default = RadioSchemaComponent;
